export class Serialize {
    constructor() {
    }

    data(inputs) {
        const inputsArray = (typeof inputs === 'object') ? Object.keys(inputs) : inputs;
        return inputsArray.map((k) => k + '=' + inputs[k]).join('&');
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/Serialize/index.js